<template>
  <div
      ref="box"
      class="pa-4 overflow-hidden position-absolute"
      style="left:0;top:0;right:0;bottom:0;"
  >
    <v-row class="rowSmall" align-content="start">
      <v-col v-if="$tools.isDefined($slots.tabs)" ref="tabs" cols="12">
        <v-sheet elevation="2" rounded class="position-relative overflow-auto">
          <slot name="tabs"/>
        </v-sheet>
      </v-col>

      <v-col v-if="$tools.isDefined($scopedSlots.nav)" cols="auto">
        <v-sheet
            :min-width="$tools.isEmpty(navWidth) ? 310 : navWidth"
            :max-width="$tools.isEmpty(navWidth) ? 310 : navWidth"
            :min-height="navHeight"
            :max-height="navHeight"
            elevation="2" rounded class="position-relative overflow-auto"
        >
          <slot name="nav" :height="navHeight"/>
        </v-sheet>
      </v-col>
      <v-col>
        <v-sheet
            :min-width="contentWidth"
            :max-width="contentWidth"
            :min-height="contentHeight"
            :max-height="contentHeight"
            elevation="2" rounded class="position-relative overflow-auto"
        >
          <slot name="content" :height="contentHeight"/>
        </v-sheet>
      </v-col>
      <v-col v-if="$tools.isDefined($scopedSlots.detail)" cols="auto">
        <v-sheet
            :min-width="$tools.isEmpty(detailWidth) ? 310 : detailWidth"
            :max-width="$tools.isEmpty(detailWidth) ? 310 : detailWidth"
            :min-height="detailHeight"
            :max-height="detailHeight"
            elevation="2" rounded class="position-relative overflow-auto"
        >
          <slot name="detail" :height="detailHeight"/>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: [
    'navWidth',
    'detailWidth',
  ],
  data: ()=>({
    navHeight:0,
    contentWidth:0,
    contentHeight:0,
    detailHeight:0,
  }),
  mounted(){
    this.resize();
    setTimeout(this.resize,250);
    setTimeout(this.resize,500);
    setTimeout(this.resize,1000);
    setTimeout(this.resize,2000);
    window.addEventListener('resize', this.resize, true);
  },
  methods:{
    resize(){
      if(!this.$tools.isDefined(this.$refs.box))
        return;
      let padding = 16;
      let box = this.$refs.box.getBoundingClientRect();
      //console.log(box.width, box.height);

      this.navHeight = box.height-(padding*2)
      this.contentWidth = box.width-(padding*2)
      this.contentHeight = box.height-(padding*2)
      this.detailHeight = box.height-(padding*2)

      if(this.$tools.isDefined(this.$scopedSlots.nav)){
        if(this.$tools.isEmpty(this.navWidth)){
          this.contentWidth -= 310+padding;
        } else {
          this.contentWidth -= parseInt(this.navWidth)+padding;
        }
      }

      if(this.$tools.isDefined(this.$scopedSlots.detail)){
        if(this.$tools.isEmpty(this.detailWidth)){
          this.contentWidth -= 310+padding;
        } else {
          this.contentWidth -= parseInt(this.detailWidth)+padding;
        }
      }

      if(this.$tools.isDefined(this.$slots.tabs)){
        this.navHeight -= 48+padding;
        this.contentHeight -= 48+padding;
        this.detailHeight -= 48+padding;
      }
    }
  }
}
</script>